<template>
  <div class="banner">
    <div class="banner-item" :style="{ backgroundImage: `url(${bgImg})` }">
      <div class="banner-search">
        <Tabs
          :tabList="searchList"
          @selectTab="selectTab"
          :selectedIndx="selectedIndx"
          :justifyContent="'left'"
        ></Tabs>
        <a-input-search
          placeholder="请输入关键字搜索"
          enter-button="查询"
          @search="handleSearch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/tabs'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      bgImg: require('@/assets/images/patentImg/banner.png'),
      searchList: [
        {
          name: '资讯',
          path: '/generalInfo',
          key: 'info'
        },
        {
          name: '人才',
          path: '/talentList',
          key: 'demand'
        },
        {
          name: '培训',
          path: '/trainKnowledgeProduce',
          key: 'info'
        },
      ],
      selectedIndx: '',
    }
  },
  components: {
    Tabs
  },
  methods: {
    ...mapMutations('headerSearch', ['updateTabValue']),
    selectTab(val) {
      this.selectedIndx = val.index
      this.selectedTab = val.tab.name
      this.tabKey = val.tab.key
      this.path = val.tab.path
    },
    // 检索
    handleSearch(v) {
      const path = this.selectedIndx !== '' ? this.path : '/searchMore'
      const { tabKey } = this
      if (v.length < 2) {
        return this.$apiStatusHandler(999, '输入检索内容至少两个字以上')
      }
      // 更新到vuex中
      this.updateTabValue({ key: tabKey, value: v })
      this.$router.push({
        path: path,
        query: {
          keywords: v
        }
      })
    },
  }
}
</script>